// TestRunReport.jsx
import React, {
    useEffect,
    forwardRef,
    useImperativeHandle,
    useRef,
} from 'react'
import { useDispatch, useSelector } from 'react-redux'
import {
    testRunDetail,
    testRunState,
} from '../../../../redux/testRun/testRunList.slice'
import { Col, Row } from 'antd'
import ChartStatus from './ChartStatus'
import ReportStats from './ReportStats'
import SkeletonReportSection from './SkeletonReportSection'

const TestRunReport = forwardRef((props, ref) => {
    const { reportId } = props
    const dispatch = useDispatch()

    const {
        testRunDetail: testRunDetailData,
        testRunDetailLoading,
        fetchReportToggle,
    } = useSelector(testRunState)

    const containerRef = useRef(null)

    const handleDetails = () => {
        dispatch(testRunDetail(reportId))
    }

    useEffect(() => {
        handleDetails()
        // eslint-disable-next-line react-hooks/exhaustive-deps
    }, [fetchReportToggle, reportId])

    // Expose inner DOM node to parent
    useImperativeHandle(ref, () => ({
        getNode: () => containerRef.current,
    }))

    if (testRunDetailLoading) return <SkeletonReportSection />

    return (
        <div style={{ width: '100%' }}>
            <div
                ref={containerRef}
                style={{
                    padding: 0,
                    height: '100%',
                    border: '1px solid #dedede',
                    borderRadius: 8,
                    background: '#fff',

                    width: '100%',
                    // minWidth: '1200px', // keeps two columns from collapsing on smaller laptops
                    boxSizing: 'border-box',
                }}
            >
                {/* <Row gutter={[16, 16]} style={{ width: '100%' }} align="middle">
                    <Col xs={24} md={11}>
                        <ChartStatus data={testRunDetailData} />
                    </Col>
                    <Col xs={24} md={12}>
                        <ReportStats
                            data={testRunDetailData?.statusSummary || []}
                        />
                    </Col>
                </Row> */}

                <div
                    style={{
                        display: 'flex',
                        flexWrap: 'wrap',
                        alignItems: 'center',
                        justifyContent: 'center',
                        gap: 22, // ✨ real gap between pie and stats
                        width: '100%',
                    }}
                >
                    <div
                        style={{
                            flex: '0 0 520px', // pie column fixed-ish width
                            width: '50%',
                        }}
                    >
                        <ChartStatus data={testRunDetailData} />
                    </div>

                    <div
                        style={{
                            display: 'flex',
                            justifyContent: 'center',
                            padding: '10px',
                            width: '50%',
                        }}
                    >
                        <ReportStats
                            data={testRunDetailData?.statusSummary || []}
                        />
                    </div>
                </div>
            </div>
        </div>
    )
})

export default TestRunReport
